import SelectOption from "app/models/selectOption";

export const businessRegulationStatusOptions: Array<SelectOption> = [
  { label: "Regulated Business", value: "regulated" },
  { label: "Unregulated Business", value: "unregulated" },
];

export const clientTransactionStatusOptions: Array<SelectOption> = [
  { label: "Self-Owned", value: "self-owned" },
  { label: "Opened on Behalf of Another", value: "on-behalf" },
];

export const REQUIRED_FIELD_ERROR = "Please fill this information to continue";

export const MAX_PERCENT_OWNERSHIP_EXCEEDED_ERROR = "Total must be 100%";

export const businessOwnerFormInitialValues = {
  first_name: "",
  last_name: "",
  role: [],
  percentage_ownership: 0,
  nationality_country_id: "NG",
  residential_country_id: "",
  street_address_1: "",
  state: "",
  city: "",
  county: "",
  postal_code: "",
  is_pep: "",
  proof_of_address: "",
  proof_of_id: "",
  pep_type: "...",
  bvn: "",
  intl_passport_num: "",
};

export const EMPTY_VALUE = "-";
export const RED_ZONES = [
  "AF",
  "AL",
  "BS",
  "BB",
  "BY",
  "BW",
  "BF",
  "KH",
  "KY",
  "CF",
  "CG",
  "CD",
  "CU",
  "ER",
  "GW",
  "HT",
  "IR",
  "IQ",
  "JM",
  "KP",
  "LB",
  "LY",
  "ML",
  "MN",
  "MA",
  "MM",
  "NI",
  "PK",
  "PA",
  "RU",
  "SO",
  "KR",
  "SS",
  "SD",
  "SY",
  "TT",
  "UG",
  "UA",
  "US",
  "VE",
  "PS",
  "YE",
  "ZW",
];

export const FIAT_CURRENCIES = ["NGN", "USD", "KES"];
